import React, { useEffect } from "react";

import Text from "components/Text";
import { Plus } from "react-bootstrap-icons"; // eslint-disable-line
import Spinner from "react-bootstrap/Spinner";
import { images } from "assets/images";
import { addPrefix } from "utils/addPrefix";

type Props = {
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  text?: string;
  src?: string;
  backgroundColor?: string;
  name?: string;
  canvasImages?;
  currentCroppedButton?;
  setCurrentCroppedButton?;
  addCroppedImageArray;
  setValue;
  value?;
};

const AddCroppedImage = ({
  color = "white",
  backgroundColor = "transparent",
  className = "cropped-image-container",
  style,
  src,
  text,
  name,
  canvasImages,
  setCurrentCroppedButton,
  currentCroppedButton,
  addCroppedImageArray,
  setValue,
  value,
}: Props) => {
  const isLicensePicture = name === "licenseNumberPicture";

  useEffect(() => {
    addCroppedImageArray.forEach((image) => {
      setValue(image.name, image.src);
    });
  }, [addCroppedImageArray, setValue]);

  const onClickImage = () => {
    if (name === currentCroppedButton) {
      setCurrentCroppedButton(null);
    } else {
      setCurrentCroppedButton(name);
    }
  };

  let styleToInject: React.CSSProperties;
  if (color) {
    styleToInject = {
      ...style,
      color,
      paddingBottom: "56.25%",
    }; // This is to keep the 16:9 ratio (change only if you change the crop ratio) TODO: move to constant
  }
  if (backgroundColor) {
    styleToInject = { ...style, backgroundColor };
  } else styleToInject = style;

  // TODO: check if this renderButton is needed
  const renderButton = () => {
    return (
      <canvas
        style={{
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#1E1E1E", // $brand-black (elements.scss)
          width: "50%",
          height: "50%",
          visibility: src ? "hidden" : "visible",
        }}
        ref={canvasImages}
        className="cropped-image"
      />
    );
  };

  return (
    <div>
      <button
        type="button"
        onClick={onClickImage}
        style={{
          ...styleToInject,
          backgroundColor: src ? "transparent" : "#1E1E1E", // $brand-black (elements.scss)
        }}
        className={className}
      >
        {renderButton()}
        {src && (
          <img
            alt={name}
            src={addPrefix(value)}
            className="cropped-image-thumbnail"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              minHeight: "30%",
              minWidth: "30%",
            }}
          />
        )}
        <span
          className="floating-inside-image"
          style={{
            visibility: src ? "hidden" : "visible",
          }}
        >
          <div className={className}>
            <div className="no-image">
              {name === currentCroppedButton ? (
                <Spinner animation="border" variant="primary" />
              ) : (
                <Plus size={30} color="#fff" />
              )}
              {text && <Text color={color}>{text}</Text>}
            </div>
          </div>
        </span>
      </button>
    </div>
  );
};
export default AddCroppedImage;
